import { useIsLiteOrg } from '@client/hooks/business/org/useIsLiteOrg';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { type DashboardSection, isLiteLockedDashboardSection } from '@shared/constants/business/lite';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { DASHBOARD_SECTION_ROUTES } from './dashboard-routes';
import { useIsDashboardsEnabled } from './hooks';

export const Route = createFileRoute('/console/$orgId/dashboard/')({
    component: DashboardHome,
});

function DashboardHome() {
    const orgId = useOrgId();
    const navigate = useNavigate();
    const isDashboardsEnabled = useIsDashboardsEnabled();
    const isLiteOrg = useIsLiteOrg();

    // Curium Lite (CUR-379): never land on a locked tab (e.g. Management overview) — pick the
    // first section that is both enabled and usable on the current plan.
    const section = Object.entries(isDashboardsEnabled).find(
        ([key, value]) => value && !(isLiteOrg && isLiteLockedDashboardSection(key as DashboardSection)),
    )?.[0] as DashboardSection | undefined;

    // Keep navigate in a ref so this redirect effect only reacts to the target route.
    const navigateRef = useRef(navigate);
    navigateRef.current = navigate;

    useEffect(() => {
        if (section) {
            navigateRef.current({
                to: DASHBOARD_SECTION_ROUTES[section],
                params: { orgId },
                replace: true,
            });
        } else {
            navigateRef.current({ to: '/console/$orgId', params: { orgId }, replace: true });
        }
    }, [orgId, section]);

    return null;
}
